import { OrderStatus, ParcelStatus, SubTaskStatus } from "generated/graphql";

export const ALL = "ALL";

export const ParcelStatusList = {
  successful: [ParcelStatus.Successful],
  cancelled: [ParcelStatus.ToReturn, ParcelStatus.Returned, ParcelStatus.Cancelled, ParcelStatus.CancelledAtRelay],
  onprogress: [
    ParcelStatus.AwaitingDelivery,
    ParcelStatus.OnDelivery,
    ParcelStatus.ToBeAssigned,
    ParcelStatus.ToHandOver,
    ParcelStatus.Delivered,
    ParcelStatus.SentBack,
    ParcelStatus.ToPick,
    ParcelStatus.Picked,
    ParcelStatus.ToReceive,
    ParcelStatus.PickFailed,
    ParcelStatus.MoneyToCollect,
    ParcelStatus.ToPrepare,
    ParcelStatus.OutOfStock,
    ParcelStatus.Dropped,
    ParcelStatus.DeliveredAtRelay,
    ParcelStatus.InRelay,
    ParcelStatus.HrOnReturn,
    ParcelStatus.HrToReturn,
    ParcelStatus.OutOfStock,
    ParcelStatus.NotCollected,
    ParcelStatus.NotCollected,
    ParcelStatus.RHandedOver,
    ParcelStatus.HandedOver,
    ParcelStatus.RToHandOver,
    ParcelStatus.RToBeAssigned,
    ParcelStatus.NotReturned,
    ParcelStatus.Failed,
    ParcelStatus.OnReturn,
  ],
};
export const OrderStatusList = {
  successful: [OrderStatus.Completed],
  cancelled: [OrderStatus.Cancelled, OrderStatus.Returned, OrderStatus.ToReturn],
  onprogress: [
    OrderStatus.AwaitingDelivery,
    OrderStatus.ToBeAssigned,
    OrderStatus.ToHandOver,
    OrderStatus.OnDelivery,
    OrderStatus.PartiallyReceived,
    OrderStatus.PartiallyCompleted,
    OrderStatus.ToPick,
    OrderStatus.ToReceive,
    OrderStatus.NotReceived,
    OrderStatus.MoneyToCollect,
    OrderStatus.ToPrepare,
    OrderStatus.ToReturn,
    OrderStatus.HandedOver,
    OrderStatus.RHandedOver,
    OrderStatus.Picked,
    OrderStatus.OutOfStock,
    OrderStatus.InRelay,
    OrderStatus.Dropped,
    OrderStatus.Delivered,
    OrderStatus.HrOnReturn,
    OrderStatus.HrToReturn,
  ],
  all: [
    OrderStatus.ToPick,
    OrderStatus.Picked,
    OrderStatus.NotReceived,
    OrderStatus.ToReceive,
    OrderStatus.NotCollected,
    OrderStatus.PartiallyReceived,
    OrderStatus.ToPrepare,
    OrderStatus.OutOfStock,
    OrderStatus.Lost,
    OrderStatus.Dropped,
    OrderStatus.ToBeAssigned,
    OrderStatus.AwaitingDelivery,
    OrderStatus.ToReturn,
    OrderStatus.ToHandOver,
    OrderStatus.HandedOver,
    OrderStatus.RHandedOver,
    OrderStatus.InRelay,
    OrderStatus.OnDelivery,
    OrderStatus.PartiallyCompleted,
    OrderStatus.Completed,
    OrderStatus.Failed,
    OrderStatus.FailedAtRelay,
    OrderStatus.Cancelled,
    OrderStatus.Delivered,
    OrderStatus.CancelledAtRelay,
    OrderStatus.DeliveredAtRelay,
    OrderStatus.MoneyToCollect,
    OrderStatus.PartiallyReceived,
    OrderStatus.Returned,
  ],
};

export const StatusToUpdate = {
  onprogress: ["TO_PICK", "TO_RECEIVE", "TO_PREPARE", "AWAITING_DELIVERY"],
};

export const SubtaskStatusList = {
  UNASSIGNED: [SubTaskStatus.Unassigned],
  ASSIGNED: [SubTaskStatus.Assigned],
  DONE: [SubTaskStatus.Done, SubTaskStatus.Cancelled],
  TO_RESCHEDULE: [SubTaskStatus.ToReschedule],
};

export const StatusTypeList: { [key: string]: { list: Object; default: string } } = {
  parcel_status: { list: ParcelStatusList, default: "onprogress" },
  order_status: { list: OrderStatusList, default: "onprogress" },
  subtask_status: { list: SubtaskStatusList, default: "DONE" },
};
